import React from "react";
import "./welcomeScreen.scss";

const WelcomeScreen = () => {
  var value = localStorage.getItem("name");
  if (value && value != "undefined") {
    var name = JSON.parse(localStorage.getItem("name"));
  }

  return (
    <div className="welcomeScreenWrapper">
      <div className="right-main-wrapper">
        {/* <img src="/images/Dashboard/Vector.png" alt="..." /> */}
        <h2>Welcome, {name} : ) </h2>
        <p>We’re here to help you to build what you want.</p>
      </div>
    </div>
  );
};

export default WelcomeScreen;
